<template>
  <div class="p-6">
    <h1 class="text-2xl font-bold mb-4">Vapi Voice Calls</h1>
    <router-view />
  </div>
</template>

<script setup>
</script>
